var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-page"},[(_vm.isLoading)?_c('div',[_c('OtherLoading',{attrs:{"variant":"dark"}})],1):_c('div',{staticClass:"content-reward"},[_c('BannerNewsSliderComponent',{attrs:{"list":_vm.bannerList,"detail":_vm.newsDetail,"date":_vm.date}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }